import { render, staticRenderFns } from "./TreeNavigation.vue?vue&type=template&id=47b89d29"
import script from "./TreeNavigation.vue?vue&type=script&lang=js"
export * from "./TreeNavigation.vue?vue&type=script&lang=js"
import style0 from "./TreeNavigation.vue?vue&type=style&index=0&id=47b89d29&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports